module.exports = __webpack_public_path__ + "img/778.04a00d66.jpg";